<!--
	@name app-app-login
	@description Public hand off page. Scanned from the QR code shown in My Account, it forwards the
	             session into the Air app, and offers the app stores when the app is not installed
	@date 2026/08/12
	@license no license
	@copywrite Answers In Retirement Limited
-->

<template>
	<div :component="$options.name" class="pa-6 text-center">
		<v-row justify="center" no-gutters>
			<v-col cols="12" sm="8" md="5">
				<v-card class="pa-6">
					<v-icon color="primary" size="56">
						mdi-cellphone-key
					</v-icon>

					<h1 class="text-h6 mt-4 mb-2">
						Opening the Air app
					</h1>
					<p class="text-body-2 blue-grey--text mb-6">
						Enter the code shown on your computer to finish signing in.
					</p>

					<v-btn color="primary" depressed block @click="openApp">
						Open the Air app
					</v-btn>

					<!-- Revealed once it is clear the app did not take over, so the copy does not
					     flash up in front of users whose app opens immediately -->
					<div v-if="showFallback" class="mt-8">
						<v-divider class="mb-6" />
						<p class="text-body-2 mb-4">
							Don't have the app yet? Download it, then scan the code again.
						</p>
						<v-btn class="mb-3" outlined block :href="appStoreUrl" target="_blank" rel="noopener">
							<v-icon left>
								mdi-apple
							</v-icon>
							App Store
						</v-btn>
						<v-btn outlined block :href="playStoreUrl" target="_blank" rel="noopener">
							<v-icon left>
								mdi-google-play
							</v-icon>
							Google Play
						</v-btn>
					</div>
				</v-card>
			</v-col>
		</v-row>
	</div>
</template>

<script>
	export default {
		name: 'app-app-login',

		props: {
			sessionId: { type: String, required: true }
		},

		data() {
			return {
				showFallback: false,
				timeout: null
			};
		},

		computed: {
			/**
			 * @name appUrl
			 * @description Deep link into the app, carrying the session only. The short code is never
			 * encoded here, so this URL on its own cannot log anybody in
			 * @return {String}
			 */
			appUrl() {
				return `airsourcing://app/app-login/${this.sessionId}`;
			},

			appStoreUrl() {
				return process.env.VUE_APP_APP_STORE_URL || 'https://apps.apple.com/gb/search?term=Air%20Sourcing';
			},

			playStoreUrl() {
				return process.env.VUE_APP_PLAY_STORE_URL || 'https://play.google.com/store/apps/details?id=com.key.airsourcing';
			}
		},

		mounted() {
			this.openApp();
			this.timeout = setTimeout(() => (this.showFallback = true), 1500);
		},

		beforeDestroy() {
			if (this.timeout) clearTimeout(this.timeout);
		},

		methods: {
			/**
			 * @name openApp
			 * @description Hand off to the app via its custom scheme
			 */
			openApp() {
				window.location.href = this.appUrl;
			}
		}
	};
</script>
